import acierto1 from "../assets/bg/acierto-avatar-1.png";

import error1 from "../assets/bg/error-avatar-1.png";

const ACIERTO_AVATARS = [acierto1];
const ERROR_AVATARS = [error1];

/** URL (bundler) de un avatar de respuesta correcta, al azar. Llamar al abrir cada modal. */
export function getRandomAciertoAvatar() {
	return ACIERTO_AVATARS[Math.floor(Math.random() * ACIERTO_AVATARS.length)];
}

/** URL (bundler) de un avatar de respuesta incorrecta, al azar. Llamar al abrir cada modal. */
export function getRandomErrorAvatar() {
	return ERROR_AVATARS[Math.floor(Math.random() * ERROR_AVATARS.length)];
}
